<div
  class="commonContainerStyle"
>
  <app-cross-close-button></app-cross-close-button>
  <div
    class="tableContainerStyle"
  >
    <table
      mat-table
      [dataSource]="listOfPlayersForManualAdd"
    >
      <ng-container matColumnDef='fullName'>
        <td
          mat-cell
          *matCellDef="let player"
          class="tableBodyCell playerName"
        >
          {{player.full_name}}
        </td>
      </ng-container>
      <ng-container matColumnDef='addButton'>
        <td
          mat-cell
          *matCellDef="let player"
          class="tableBodyCell"
        >
          <button
            class='btn btn-log btn-sm buttonStyle'
            (click)="addPlayerManually(player.id)"
          >
            Добавить игрока
          </button>
        </td>
      </ng-container>
      <tr
        mat-row
        *matRowDef="let row; columns: getDisplayedColumns();"
      ></tr>
    </table>
  </div>
</div>
